export default "__VITE_ASSET__BcA7dpiH__"